import { useState } from "react";
import { ButtonPrimary } from "../../../components/NewButtons";
import { BarcodeModal } from "./BarcodeModal";
import { ProductBarcode } from "../models/product";

type Props = {
  onSubmit: (barcode: ProductBarcode) => void;
};

export const BarcodeSelector = ({ onSubmit }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ButtonPrimary
        onClick={() => {
          setIsOpen(true);
        }}
      >
        Add barcode
      </ButtonPrimary>
      <BarcodeModal
        isOpen={isOpen}
        handleClose={() => {
          setIsOpen(false);
        }}
        onSubmit={onSubmit}
      />
    </>
  );
};
